import React from "react";
import BookingTable from "../BookingTable";

const CompletedTab = ({ loading }: any) => {
  const columns = [
    "Office Name",
    "Property Details",
    "Duration",
    "Booking Date",
    "Total Fee",
    "",
    "Action",
  ];

  return <BookingTable columns={columns} loading={loading} />;
};

export default CompletedTab;
